import { Address } from "../../models/address";
import { Adjuster } from "../../models/adjuster";
import { Carrier } from "../../models/carrier";
import { User, Email } from "@harlowe/core";
import { Party } from "@harlowe/core";
import { Phone } from "../../models/phone";
import { TealCompClaim } from "../../models/teal-comp-claim";

export namespace Claims 
{

    export class UserLoggedIn
    {
        static readonly type = "[Claim Login Action] Successful Login";
        constructor(public payload: { user: User }) {}
    }

    export class ClaimServiceOpenClaim
    {
        static readonly type="[Claim Service] Open Claim";
        constructor(public payload: {claim :TealCompClaim}) {}
    }


    export class ClaimStateCloseClaim
    {
        static readonly type="[Claim State] Close Claim";
        constructor(public payload: {claim:TealCompClaim}) {}
    }

    export class ClaimStateOpenClaim
    {
        static readonly type="[Claim State] Open Claim";
        constructor(public payload: {claim :TealCompClaim}) {}
    }

    export class PersistState
    {
        static readonly type="[Claim State] Persist";
    }


    export class PartyStatePartyUpdated
    {
        static readonly type="[Party State] Party Updated";
        constructor(public payload: {party: Party}){}
    }


    export class ClaimServiceClaimUpdated
    {
        static readonly type="[Claim Service] Claim Updated";
        constructor(public payload: {claim: TealCompClaim}){}
    }

    export class ClaimServiceCarrierUpdated
    {
        static readonly type="[Claim Service] Carrier Updated";
        constructor(public payload: {carrier: Carrier}){} 
    }

    export class ClaimServiceAdjusterUpdated
    {
        static readonly type="[Claim Service] Adjuster Updated";
        constructor(public payload: {adjuster: Adjuster}){} 
    }

    export class ClaimCardClaimClosed
    {
        static readonly type="[Claim Card] Claim Closed";
        constructor(public payload: {claim: TealCompClaim}){}
    }

}